import React, { useContext, useEffect, useState } from 'react';

import { useLocation, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Grid from "@mui/material/Grid";
import Icon from '@mui/material/Icon';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import SoftAvatar from "components/SoftAvatar";
import SidenavCollapse from 'examples/Sidenav/SidenavCollapse';
import SidenavCard from 'examples/Sidenav/SidenavCard';
import SidenavRoot from 'examples/Sidenav/SidenavRoot';
import sidenavLogoLabel from 'examples/Sidenav/styles/sidenav';
import { useSoftUIController, setMiniSidenav, setselectedPropertyId } from 'context';
import AuthContext from "context/AuthContext";
import refreshAccessToken from 'adminRefresToken';
import getCSRFToken from 'csrftoken';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

function Sidenav({ color, brand, brandName, routes, ...rest }) {

  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentSidenav, selectedPropertyId } = controller;
  const location = useLocation();
  const { pathname } = location;
  const [activeRoute, setActiveRoute] = useState('');
  const navigate = useNavigate();
  // const isRouteActive = (route) => pathname.startsWith(route);
  const isRouteActive = (routeObj) => {
    // If activePaths is defined, check those
    if (routeObj.activePaths && routeObj.activePaths.length > 0) {
      return routeObj.activePaths.some((path) =>
        pathname.startsWith(path)
      );
    }

    // Default behavior
    return pathname.startsWith(routeObj.route);
  };

  const { adminauthTokens, authTokens, staffauthTokens, managerauthTokens, logoutUser } = useContext(AuthContext);
  const { isAdmin, isManager, isStaff, isUser, isSuperAdmin } = useAuth();

  //console.log(staffauthTokens);

  const showSelectButton = adminauthTokens || authTokens || staffauthTokens || managerauthTokens;

  const selectedAuthToken = authTokens || staffauthTokens || managerauthTokens || adminauthTokens;

  const [profiledata, setProfileData] = useState(null);
  const [unitdata, setUnitData] = useState(null);

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    window.addEventListener('resize', handleMiniSidenav);
    handleMiniSidenav();

    return () => window.removeEventListener('resize', handleMiniSidenav);
  }, [dispatch, location]);

  const handleCollapseClick = (key) => {
    setActiveRoute(activeRoute === key ? '' : key);
  };

  const renderRoutes = routes.map(
    ({ type, name, icon, title, noCollapse, key, route, href, children, activePaths }) => {
      let returnValue;

      if (type === 'collapse') {
        const isActive = activeRoute === key;

        returnValue = (
          <React.Fragment key={key} >
            <NavLink
              to={route} key={key}
              rel="noreferrer"
              sx={{ textDecoration: 'none' }}
              onClick={() => handleCollapseClick(key)}
            >
              <SidenavCollapse
                color={color}
                name={name}
                icon={icon}
                active={isRouteActive({ route, activePaths })}
                noCollapse={noCollapse}
              />
            </NavLink>
            {isActive && Array.isArray(children) && (
              <List sx={{ pl: 3 }}>
                {children.map(
                  ({ type: childType, name: childName, icon: childIcon, route: childRoute, key: childKey }) =>
                    childType === 'item' ? (
                      <NavLink to={childRoute} key={childKey}>
                        <SidenavCollapse
                          color={color}
                          name={childName}
                          icon={childIcon}
                          active={pathname === childRoute}
                        />
                      </NavLink>
                    ) : null
                )}
              </List>
            )}
          </React.Fragment>
        );
      } else if (type === 'title') {
        returnValue = (
          <SoftTypography
            key={key}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            opacity={0.6}
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </SoftTypography>
        );
      } else if (type === 'divider') {
        returnValue = <Divider key={key} />;
      }

      return returnValue;
    }
  );

  const [user_property, setUserProperty] = useState([]);

  // useEffect(() => {
  //   fetchData();
  // }, []);


  // const fetchData = async () => {
  //   try {
  //     const newAccessToken = await refreshAccessToken(showSelectButton?.refresh);
  //     const response = await fetch("https://hgpro.nyc/manager/api/my/property",
  //       {
  //         method: "GET",
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-CSRFToken': getCSRFToken(),
  //           'Authorization': `Bearer ${newAccessToken}`,
  //         },
  //         credentials: 'include',
  //       }
  //     );
  //     const data = await response.json();
  //     //console.log(data.property)
  //     setUserProperty(data.property);
  //     {
  //       authTokens && (
  //         setUnitData(data.unit_id)
  //       )
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // const fetchProfileData = async () => {
  //   try {
  //     const newAccessToken = await refreshAccessToken(selectedAuthToken?.refresh);
  //     const response = await fetch("https://hgpro.nyc/authentication/api/profile",
  //       {
  //         method: "GET",
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-CSRFToken': getCSRFToken(),
  //           'Authorization': `Bearer ${newAccessToken}`,
  //         },
  //         credentials: 'include',

  //       }
  //     );
  //     const data = await response.json();
  //     //console.log(data)
  //     setProfileData(data.profile); // Set the fetched data in the state
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchProfileData();
  // }, []);


  const handlePropertySelect = async (event) => {
    const selectedPropertyId = event.target.value;
    //console.log("Selected Property ID:", selectedPropertyId);
    setselectedPropertyId(dispatch, selectedPropertyId);

    try {
      const newAccessToken = await refreshAccessToken(showSelectButton?.refresh);
      const response = await fetch("https://hgpro.nyc/manager/api/my/selected/property", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCSRFToken(),
          'Authorization': `Bearer ${newAccessToken}`,
        },
        credentials: 'include',
        body: JSON.stringify({ selectedPropertyId }), // Sending the selected property ID in the request body
      });

      if (response.status === 200) {
        //console.log("Selected property updated successfully.");
      } else {
        console.error("Failed to update selected property.");
      }
    } catch (error) {
      console.error("Error updating selected property:", error);
    }
  };


  const renderPropertyInfo = () => {
    if (user_property && showSelectButton) {
      return (
        <>
          {managerauthTokens && (
            <>
              <Divider />
              <SoftBox>
                <select style={{ width: "100%", padding: "5px", borderRadius: "5px", cursor: "pointer" }} value={selectedPropertyId} onChange={handlePropertySelect}>
                  <option>Select Property</option>
                  {user_property &&
                    (
                      user_property.map(p => (
                        <option key={p.property_id} value={p.property_id}>
                          {p.title} ( {p.property_id} )
                        </option>
                      ))

                    )}
                </select>
              </SoftBox>
            </>
          )}
          {/* {authTokens && (
            <>
              <Divider />
              <SoftBox>
                <select style={{ width: "100%", padding: "5px", borderRadius: "5px", cursor: "pointer" }} value={selectedPropertyId} onChange={handlePropertySelect}>
                  <option>Select Property</option>
                  {user_property.map(p => (
                    <option key={p.property.property_id} value={p.property.property_id}>
                      {p.property.title} ( {p.property.property_id} )
                    </option>
                  ))}
                </select>
              </SoftBox>
            </>
          )} */}
          {staffauthTokens && (
            <>
              <Divider />
              <SoftBox>
                <select style={{ width: "100%", padding: "5px", borderRadius: "5px", cursor: "pointer" }} value={selectedPropertyId} onChange={handlePropertySelect}>
                  <option>Select Property</option>
                  {user_property &&
                    (
                      user_property.map(p => (
                        <option key={p.property.property_id} value={p.property.property_id}>
                          {p.property.title} ( {p.property.property_id} )
                        </option>
                      )))}
                </select>
              </SoftBox>
            </>
          )}
        </>
      );
    }
    return null;
  };

  const parts = brandName.split(' | ');

    const getRolePrefix = () => {
    if (isSuperAdmin) return "/super-admin";
    if (isAdmin) return "/admin";
    if (isManager) return "/manager";
    if (isStaff) return "/concierge";
    if (isUser) return "/user";
    return "";
  };

  const dashboardLink = `${getRolePrefix()}/dashboard`;

  const handleLogoClick = () => {
    navigate(`${dashboardLink}`);
  }

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>

      <SoftBox pt={3} pb={1} px={4} textAlign="center">
        <SoftBox
          display={{ xs: 'block', xl: 'none' }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: 'pointer' }}
        >
          <SoftTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: 'bold' }}>close</Icon>
          </SoftTypography>
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          {/* {brand && <SoftBox component="img" src={brand} alt="HG Pro" width="2rem" />} */}
          {/* {<SoftBox  alt="HG Pro" width="2rem" />} */}
          <SoftBox width={!brandName && '100%'}>
            {showSelectButton && (
              <SoftBox container spacing={3} >
                {profiledata && (
                  <>
                    <SoftBox style={{ display: "flex" }}>
                      <SoftAvatar
                        src={profiledata.image ? `https://hgpro.nyc${profiledata.image}` : null}
                        alt="profile-image"
                        variant="rounded"
                        size="m"
                        shadow="sm"
                      />
                      &nbsp; &nbsp;
                      <SoftBox mt={0.5} lineHeight={1} sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
                        <SoftTypography variant="h6" fontWeight="medium">
                          {parts[0]}<br />
                          {parts[1]}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                  </>
                )}

              </SoftBox>
            )}
            {profiledata && (

              <SoftTypography component="h3" fontWeight="medium">
                {profiledata.user.first_name} {profiledata.user.last_name} {unitdata && (
                  <span>| {unitdata}</span>
                )}
              </SoftTypography>
            )}
          </SoftBox>
        </SoftBox>
        {renderPropertyInfo()}

      </SoftBox>
      <SoftBox display="flex" justifyContent="center">
        <SoftBox
          component="img"
          src="/hgpro-logo.png"
          alt="Company Logo"
          sx={{
            width: miniSidenav ? 40 : 120,
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onClick={handleLogoClick}/>
      </SoftBox>
      <Divider />
      <List>{renderRoutes}</List>

    </SidenavRoot>
  );
}

Sidenav.defaultProps = {
  color: 'info',
  brand: '',
};

Sidenav.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error', 'dark']),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
